<template>
  <div class="mainNew">
    <div class="topTitle">
      <span style="font-family:'PingFangBold';color:#333333;font-size: 16px;">线索管理</span>
      / 邀约查询
    </div>
    <div class="input-student-management">
      <section>
        <el-form style="margin-top: 10px" :inline="true" size="mini">
          <el-form-item label="学员姓名:">
            <el-input style="width: 250px" v-model="form3.realname" placeholder="请输入姓名" @keyup.enter.native="search1" clearable></el-input>
          </el-form-item>
          <el-form-item label="联系电话:">
            <el-input style="width: 250px" v-model="form3.phone_num" placeholder="请输入联系电话" @keyup.enter.native="search1" clearable></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="search1" v-if="$attrs.methodAuthTabView('查询')">查询</el-button>
          </el-form-item>

          <br />

          <el-form-item label="负责人:" v-if="$attrs.methodAuthTabView('查询').viewScope !== 1">
            <el-select clearable v-model="form3.leader" placeholder="请选择主责任人" style="width: 200px" @change="search1">
              <el-option v-for="item in user_list" :key="item.id" :label="item.realname + '(' + item.name + ')'" :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="诺到访日:">
            <el-date-picker v-model="form3.date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']" @change="search1" placement="bottom-start"></el-date-picker>
          </el-form-item>

          <el-form-item label="实到访日:">
            <el-date-picker v-model="form3.date1" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']" @change="search1" placement="bottom-start"></el-date-picker>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
        <el-row>
          <el-col :span="24">
            <div>
              <el-button size="mini" plain @click="exportExcel" v-if="$attrs.methodAuthTabView('导出excel')">导出excel</el-button>
            </div>
          </el-col>
        </el-row>

        <div>
          <el-table id="outLTable" size="mini" ref="multipleTable" :data="sure_student_list" tooltip-effect="dark" style="width: 100%; margin-top: 20px;" @selection-change="handleSelectionChange" :header-cell-style="{ background: '#f5f7fa', color: '#909399' }" stripe>
            <!-- <el-table-column type="selection" width="55"></el-table-column> -->

            <el-table-column align="center" width="50" label="序号" fixed="left">
              <template slot-scope="scope">
                <span>{{
                  scope.$index + 1 + (page_no2 - 1) * page_size2
                }}</span>
              </template>
            </el-table-column>

            <el-table-column label="学员姓名">
              <template slot-scope="scope">
                <span>{{ scope.row.studentUserInfo.realname }}</span>
              </template>
            </el-table-column>

            <el-table-column label="性别">
              <template slot-scope="scope">
                <span>{{ scope.row.studentUserInfo.sex }}</span>
              </template>
            </el-table-column>

            <el-table-column label="联系电话">
              <template slot-scope="scope">
                <span v-if="scope.row.studentUserInfo.parent_a === null">
                </span>

                <span v-else>
                  {{
                    scope.row.studentUserInfo.parent_a +
                      ' ' +
                      scope.row.studentUserInfo.parent_a_phone_num
                  }}
                </span>
              </template>
            </el-table-column>

            <el-table-column label="年级">
              <template slot-scope="scope">
                <span v-if="scope.row.studentUserInfo.grade == '1'">幼儿园小班</span>
                <span v-else-if="scope.row.studentUserInfo.grade == '2'">幼儿园中班</span>
                <span v-else-if="scope.row.studentUserInfo.grade == '3'">幼儿园大班</span>
                <span v-else-if="scope.row.studentUserInfo.grade == '4'">一年级</span>
                <span v-else-if="scope.row.studentUserInfo.grade == '5'">二年级</span>
                <span v-else-if="scope.row.studentUserInfo.grade == '6'">三年级</span>
                <span v-else-if="scope.row.studentUserInfo.grade == '7'">四年级</span>
                <span v-else-if="scope.row.studentUserInfo.grade == '8'">五年级</span>
                <span v-else-if="scope.row.studentUserInfo.grade == '9'">六年级</span>
                <span v-else-if="scope.row.studentUserInfo.grade == '10'">初一</span>
                <span v-else-if="scope.row.studentUserInfo.grade == '11'">初二</span>
                <span v-else-if="scope.row.studentUserInfo.grade == '12'">初三</span>
                <span v-else-if="scope.row.studentUserInfo.grade == '13'">高一</span>
                <span v-else-if="scope.row.studentUserInfo.grade == '14'">高二</span>
                <span v-else-if="scope.row.studentUserInfo.grade == '15'">高三</span>
              </template>
            </el-table-column>

            <el-table-column label="负责人">
              <template slot-scope="scope">
                <span>{{ scope.row.studentUserInfo.leaderName }}</span>
              </template>
            </el-table-column>

            <el-table-column label="诺到访日">
              <template slot-scope="scope">
                <span>{{ scope.row.come_date.slice(0, 16) }}</span>
              </template>
            </el-table-column>

            <el-table-column label="实到访日">
              <template slot-scope="scope">
                <span v-if="scope.row.real_come_date">{{
                  scope.row.real_come_date.slice(0, 16)
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="状态">
              <template slot-scope="scope">
                <span style="color: #e6a23c" v-if="scope.row.real_come_date === null">未到</span>
                <span style="color: green" v-else>已到</span>
              </template>
            </el-table-column>

            <el-table-column label="是否到访" width="100">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="
                    updateRealComeDate(
                      scope.row.real_come_date,
                      scope.row.come_date,
                      scope.row.id
                    )
                  ">
                  已到
                </el-button>
                <el-button type="text" size="mini" @click="
                    notArrived(
                      scope.row.real_come_date,
                      scope.row.come_date,
                      scope.row.id
                    )
                  ">
                  未到
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-style">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange2" :current-page="page_no2" :page-sizes="[10, 15, 20, 30, 40, 50, 100]" :page-size="page_size2" layout="total,sizes, prev, pager, next, jumper" :total="total2"></el-pagination>
        </div>
      </section>

      <!--提示框-->
      <!-- <el-dialog title="取消转化" :visible.sync="dialogFormVisible5" width="50%">
        <span>该操作将取消意向客户与正式学员的转化关系！确定取消吗？</span>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogFormVisible5 = false">取 消</el-button>
          <el-button size="small" type="primary" @click="cancelIntendedRelation">确 定</el-button>
        </span>
      </el-dialog> -->

      <!--修改学员信息-->
      <el-dialog width="65%" title="基础信息" :visible.sync="dialogFormVisible7">
        <el-form ref="updateform" label-width="120px" class="form-style" :model="updateform" :rules="rules" size="mini">
          <el-row>
            <el-col :span="12">
              <div>
                <el-form-item label="学员姓名" required prop="realname">
                  <el-input v-model="updateform.realname" style="width: 300px" placeholder="请输入学员姓名"></el-input>
                </el-form-item>
              </div>
            </el-col>

            <el-col :span="12">
              <div>
                <el-form-item label="学员账号" required>
                  <el-input v-model="updateform.parent_a_phone_num" style="width: 300px" placeholder="学员账号默认为家长A手机号" disabled></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <div>
                <el-form-item label="学员性别" required prop="sex">
                  <el-radio-group v-model="updateform.sex">
                    <el-radio label="男"></el-radio>
                    <el-radio label="女"></el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <el-form-item label="出生日期">
                  <el-date-picker type="date" placeholder="请选择出生日期" v-model="updateform.birthday" style="width: 300px" value-format="yyyy-MM-dd" placement="bottom-start"></el-date-picker>
                </el-form-item>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <div>
                <el-form-item label="所在学校">
                  <el-input v-model="updateform.school_name" style="width: 300px" placeholder="请输入所在公立学校"></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <el-form-item label="在校年级">
                  <el-select v-model="updateform.grade" placeholder="请选择在校年级" style="width: 300px">
                    <el-option label="幼儿园小班" :value="1"></el-option>
                    <el-option label="幼儿园中班" :value="2"></el-option>
                    <el-option label="幼儿园大班" :value="3"></el-option>
                    <el-option label="一年级" :value="4"></el-option>
                    <el-option label="二年级" :value="5"></el-option>
                    <el-option label="三年级" :value="6"></el-option>
                    <el-option label="四年级" :value="7"></el-option>
                    <el-option label="五年级" :value="8"></el-option>
                    <el-option label="六年级" :value="9"></el-option>
                    <el-option label="初一" :value="10"></el-option>
                    <el-option label="初二" :value="11"></el-option>
                    <el-option label="初三" :value="12"></el-option>
                    <el-option label="高一" :value="13"></el-option>
                    <el-option label="高二" :value="14"></el-option>
                    <el-option label="高三" :value="15"></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <div>
                <el-form-item label="联系电话">
                  <el-select v-model="updateform.parent_a" style="width: 100px">
                    <el-option label="父亲" value="父亲"></el-option>
                    <el-option label="母亲" value="母亲"></el-option>
                    <el-option label="其他" value="其他"></el-option>
                  </el-select>
                  <el-input v-model="updateform.parent_a_phone_num" placeholder="请输入手机号" style="width: 180px; margin-left: 20px"></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <el-form-item label="微信" prop="parent_b_phone_num">
                  <el-select v-model="updateform.parent_b" style="width: 100px">
                    <el-option label="父亲" value="父亲"></el-option>
                    <el-option label="母亲" value="母亲"></el-option>
                    <el-option label="其他" value="其他"></el-option>
                  </el-select>
                  <el-input v-model="updateform.parent_b_phone_num" placeholder="请输入微信号" style="width: 180px; margin-left: 20px"></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <div>
                <el-form-item label="主责任人">
                  <el-select v-model="updateform.leader" placeholder="请选择主责任人" style="width: 300px">
                    <el-option v-for="item in user_list" :key="item.id" :label="item.realname" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>

            <el-col :span="12">
              <div>
                <el-form-item label="客户状态" required prop="state">
                  <el-select v-model="updateform.state" placeholder="请选择客户状态" style="width: 300px" :disabled="updateform.state == 1">
                    <el-option label="未上门" :value="2"></el-option>
                    <el-option label="已试听未转化" :value="3"></el-option>
                    <el-option label="试听A（意向高 购买力强）" :value="4"></el-option>
                    <el-option label="试听B（意向一般 购买力强）" :value="5"></el-option>
                    <el-option label="试听C（意向高 购买力弱）" :value="6"></el-option>
                    <el-option label="试听D（无意向 无购买力）" :value="7"></el-option>
                    <el-option label="转化成功" :value="1"></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <div>
                <el-form-item label="所属校区">
                  <el-select v-model="updateform.educational_institution_campus_id" placeholder="请选择所属校区" style="width: 300px" @change="getCampusUserList">
                    <el-option v-for="(item, index) of school_list" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>

            <el-col :span="12">
              <div>
                <el-form-item label="意向级别" required prop="intended_level">
                  <el-select v-model="updateform.intended_level" placeholder="请选择意向级别" style="width: 300px">
                    <el-option label="1级" :value="1"></el-option>
                    <el-option label="2级" :value="2"></el-option>
                    <el-option label="3级" :value="3"></el-option>
                    <el-option label="4级" :value="4"></el-option>
                    <el-option label="5级" :value="5"></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div>
                <el-form-item label="备注信息">
                  <el-input style="width: 300px" type="textarea" v-model="updateform.remark"></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <!-- <el-row>
          <el-col :span="12">
            <div>
              <el-form-item label="结束状态">
                <el-select v-model="updateform.status" placeholder="请选择意向级别" style="width: 300px">
                  <el-option label="已结束" :value="1"></el-option>
                  <el-option label="未结束" :value="0"></el-option>

                </el-select>
              </el-form-item>
            </div>
          </el-col>

        </el-row> -->
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogFormVisible7 = false">取 消</el-button>
          <el-button size="small" type="primary" @click="addOrUpdateIntendedStudent('updateform')">修 改</el-button>
        </div>
      </el-dialog>

      <el-dialog title="添加学员" :visible.sync="dialogVisible" width="50%">
        <el-row>
          <el-col :span="12">
            <div class="grid-content bg-purple">
              <el-upload action="/" :on-change="onChange" :auto-upload="false" :show-file-list="false" accept=".xls, .xlsx">
                <el-button size="mini">
                  导入意向学员
                  <i class="el-icon-upload el-icon--right"></i>
                </el-button>
              </el-upload>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="grid-content bg-purple-light">
              <el-tooltip placement="top">
                <div slot="content">
                  【注意事项】
                  <br />1、性别统一以中文输入"男"或者"女";
                  <br />2、家长统一以中文输入"父亲"、"母亲"或者"其他"";
                  <br />3、所有字段内容不能为空;
                  <br />4、批量导入每次最多导入50人;
                  <br />
                  <br />【录入示例】 <br />王晓明 男 18722160555
                </div>
                <el-link style="float: right" icon="el-icon-document" @click="DownLoadExcel">下载Excel模板</el-link>
              </el-tooltip>
            </div>
          </el-col>
        </el-row>

        <el-table size="mini" height="300" :data="outputs" style="width: 100%; margin-top: 20px" :header-cell-style="{ background: '#f5f7fa' }">
          <el-table-column prop="realname" label="姓名" align="center"></el-table-column>
          <el-table-column prop="sex" label="性别" align="center"></el-table-column>
          <el-table-column prop="parent_a" label="家长" align="center"></el-table-column>

          <el-table-column prop="parent_a_phone_num" label="手机号" align="center"></el-table-column>

          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="Deleteoutputs(scope.$index)">移除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="ClearMultiStudent">暂不添加</el-button>

          <el-button size="small" type="primary" @click="MultiAddStudent">确认添加</el-button>
        </span>
      </el-dialog>

      <el-drawer title="跟进记录" :visible.sync="drawer" :direction="direction">
        <div>
          <div style="margin: 10px">
            <el-divider direction="vertical"></el-divider>
            <span style="font-size: 16px; color: #333; line-height: 28px">主责任人</span>
          </div>

          <div>
            <el-tooltip class="item" effect="dark" :content="updateform.leaderName" placement="top">
              <el-avatar style="margin-left: 20px" shape="square" :size="50" :src="updateform.userImageUrl"></el-avatar>
            </el-tooltip>
          </div>

          <div style="margin-top: 20px">
            <div style="margin-left: 10px">
              <el-divider direction="vertical"></el-divider>
              <span style="font-size: 16px; color: #333; line-height: 28px">跟进动态</span>

              <span style="
                    color: #529dfe;
                    line-height: 28px;
                    float: right;
                    margin-right: 20px;
                    cursor: pointer;
                  " @click="OverIntentRecord('0')" v-if="updateform.is_over">结束</span>

              <span style="
                    color: #529dfe;
                    line-height: 28px;
                    float: right;
                    margin-right: 20px;
                    cursor: pointer;
                  " @click="OverIntentRecord('1')" v-if="!updateform.is_over">恢复</span>
            </div>

            <div style="
                  border: 1px solid #e5e9f2;
                  text-align: center;
                  padding: 20px;
                  margin: 20px;
                  border-radius: 5px;
                  line-height: 22px;
                  font-size: 14px;
                  cursor: pointer;
                  color: #909399;
                " v-if="flowinput" @click="OpenFlowInput">
              <i class="el-icon-edit"></i>
              <span>发布跟进记录</span>
            </div>

            <div class="flowrecord" v-if="flowinput && recordList.length > 0">
              <div>全部记录</div>

              <div style="margin-top: 10px" v-for="item of recordList" :key="item.id">
                <el-card shadow="hover">
                  <div style="margin-bottom: 10px">
                    <span style="color: rgb(145, 149, 158); font-size: 14px">跟进人:</span>
                    <span style="margin-left: 10px; font-size: 14px">
                      {{ item.link_man_name }}
                    </span>

                    <i style="float: right; cursor: pointer" class="el-icon-delete" @click="deleteIntendedStudentUserRecord(item)"></i>

                    <i style="float: right; margin-right: 20px; cursor: pointer" class="el-icon-edit" @click="EditUserRecord(item)"></i>
                  </div>

                  <div style="margin-bottom: 10px">
                    <span style="color: rgb(145, 149, 158); font-size: 14px">跟进日期:</span>
                    <span style="margin-left: 10px; font-size: 14px">
                      {{ item.created_time }}
                    </span>
                  </div>

                  <div style="margin-bottom: 10px">
                    <span style="color: rgb(145, 149, 158); font-size: 14px">记录内容:</span>
                    <span style="margin-left: 10px; font-size: 14px">
                      {{ item.remark }}
                    </span>
                  </div>

                  <div style="margin-bottom: 10px">
                    <span style="color: rgb(145, 149, 158); font-size: 14px">跟进类型:</span>
                    <span style="margin-left: 10px; font-size: 14px">
                      <span v-if="item.record_type == '1'">微信沟通</span>
                      <span v-else-if="item.record_type == '2'">电话呼出</span>
                      <span v-else-if="item.record_type == '3'">电话呼入</span>
                      <span v-else-if="item.record_type == '4'">面谈</span>
                      <span v-else-if="item.record_type == '5'">微信呼出</span>
                      <span v-else-if="item.record_type == '6'">微信呼入</span>

                      <span v-else-if="item.record_type == '7'">其他</span>
                    </span>
                  </div>

                  <div style="margin-bottom: 10px">
                    <span style="color: rgb(145, 149, 158); font-size: 14px">下次跟进:</span>
                    <span style="margin-left: 10px; font-size: 14px">
                      {{ item.next_date }}
                    </span>
                  </div>
                </el-card>
              </div>

              <div style="margin: 20px; text-align: right">
                <el-pagination @current-change="handleCurrentChange1" :current-page="page_no1" :page-size="page_size1" layout="total, prev, pager, next, jumper" :total="total1"></el-pagination>
              </div>
            </div>

            <div v-if="!flowinput">
              <div style="
                    margin-left: 20px;
                    margin-top: 20px;
                    color: #91959e;
                    font-size: 14px;
                  ">
                <span>发布跟进记录</span>
                <i class="el-icon-close" style="
                      float: right;
                      margin-right: 20px;
                      font-size: 16px;
                      cursor: pointer;
                      font-weight: bold;
                    " @click="CloseFlowInput"></i>
              </div>

              <div>
                <div style="margin-left: 30px; margin-top: 10px; font-size: 12px">
                  记录内容
                  <span style="color: red">*</span>
                </div>

                <div style="margin: 20px">
                  <el-input type="textarea" :rows="4" placeholder="请输入跟进内容" v-model="form_flow.remark"></el-input>

                  <el-form ref="form" style="margin-top: 20px" label-width="80px" size="mini">
                    <el-form-item label="跟进类型" required>
                      <el-select v-model="form_flow.record_type" placeholder="请选择跟进类型" style="width: 200px">
                        <el-option label="微信沟通" :value="1"></el-option>
                        <el-option label="电话呼出" :value="2"></el-option>
                        <el-option label="电话呼入" :value="3"></el-option>
                        <el-option label="面谈" :value="4"></el-option>
                        <el-option label="微信呼出" :value="5"></el-option>
                        <el-option label="微信呼入" :value="6"></el-option>
                        <el-option label="其他" :value="7"></el-option>
                      </el-select>
                    </el-form-item>

                    <!-- <el-form-item label="沟通效果">
                    <el-radio-group v-model="form_flow.record_status" size="medium">
                      <el-radio label="1">有效</el-radio>
                      <el-radio label="0">无效</el-radio>
                    </el-radio-group>
                  </el-form-item> -->

                    <!-- <el-form-item label="承诺到访">
                    <el-radio-group v-model="form_flow.if_come_state" size="medium">
                      <el-radio label="1">是</el-radio>
                      <el-radio label="0">否</el-radio>
                    </el-radio-group>
                  </el-form-item> -->

                    <el-form-item label="到访日期" v-if="form_flow.if_come_state == '1'">
                      <el-col :span="11">
                        <el-date-picker v-model="form_flow.come_date" type="datetime" placeholder="选择日期时间" style="width: 200px" value-format="yyyy-MM-dd HH:mm:ss" placement="bottom-start"></el-date-picker>
                      </el-col>
                    </el-form-item>

                    <!-- <el-form-item label="意向级别">
                    <el-rate v-model="form_flow.value"></el-rate>
                  </el-form-item> -->

                    <!-- <el-form-item label="客户状态">
                    <el-select v-model="form_flow.state" placeholder="请选择客户状态" style="width: 200px">
                      <el-option label="未上门" :value="2"></el-option>
                      <el-option label="已试听未转化" :value="3"></el-option>
                      <el-option label="试听A(意向高购买力强)" :value="4"></el-option>
                      <el-option label="试听B(意向一般购买力强)" :value="5"></el-option>
                      <el-option label="试听C(意向高购买力弱)" :value="6"></el-option>
                      <el-option label="无意向无购买力" :value="7"></el-option>
                    </el-select>
                  </el-form-item> -->

                    <el-form-item label="下次跟进">
                      <el-col :span="11">
                        <el-date-picker type="datetime" placeholder="选择日期" v-model="form_flow.next_date" style="width: 200px" value-format="yyyy-MM-dd HH:mm:ss" placement="bottom-start"></el-date-picker>
                      </el-col>
                    </el-form-item>

                    <el-form-item size="small">
                      <el-button type="primary" @click="addOrUpdateIntendedStudentUseRecord">发布记录</el-button>
                      <el-button @click="CloseFlowInput">取消</el-button>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-drawer>

      <el-dialog title="实际到访时间" :visible.sync="dialogVisible1" width="400px">
        <el-date-picker v-model="UpdateRealForm.real_come_date" type="datetime" placeholder="选择日期时间" style="width: 360px" value-format="yyyy-MM-dd HH:mm:ss" placement="bottom-start"></el-date-picker>

        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible1 = false">取 消</el-button>
          <el-button size="small" type="primary" @click="updateIntendedStudentRealComeDate">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  updateIndendedStudentToAuditionOrNormalOnly,
  // cancelIntendedRelation,
  getEducationalInstitutionCampusList,
  getCampusUserList,
  addOrUpdateIntendedStudent,
  bulkAddIntendedStudent,
  addOrUpdateIntendedStudentUseRecord,
  getIntendedStudentUserRecordList,
  getIntendedStudentListByRealComeDate,
  updateIntendedStudentRealComeDate,
  deleteIntendedStudentUserRecord,
  updateIntendedStudentStatus,
} from '@/api/educational.js'

import XLSX from 'xlsx'
import FileSaver from 'file-saver'

export default {
  name: 'input-student-management',
  data() {
    var validatePass = (rule, value, callback) => {
      if (!/^1[1234567890]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    var validatePhone = (rule, value, callback) => {
      if (value && !/^1[1234567890]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }

    return {
      //意向学员转公开课试听学员
      chooseStudents: [], //选择的意向学员
      FailureStudentList: [], //失败学员列表
      form2: {
        intendedStudentInfo: [],
        intendedStudentIds: [],
        opearte_state: '1', //仅转试听
      },

      rules: {
        sex: [
          {
            required: true,
            message: '请选择性别',
            trigger: 'change',
          },
        ],

        leader: [
          {
            required: true,
            message: '请选择主负责人',
            trigger: 'change',
          },
        ],
        intended_level: [
          {
            required: true,
            message: '请选择意向级别',
            trigger: 'change',
          },
        ],

        state: [
          {
            required: true,
            message: '请选择客户状态',
            trigger: 'change',
          },
        ],

        nickname: [
          {
            required: true,
            message: '请输入学生昵称',
            trigger: 'change',
          },
        ],
        realname: [
          {
            required: true,
            message: '请输入学员姓名',
            trigger: 'change',
          },
        ],
        parent_a_phone_num: [
          { required: true, message: '请输入联系电话', trigger: 'change' },
          { validator: validatePass, trigger: 'blur' },
        ],
        parent_b_phone_num: [{ validator: validatePhone, trigger: 'change' }],
      },
      intendedUserId: '',
      valueTime: '',
      //修改学员信息
      updateform: {
        id: '',
        realname: '',
        sex: '',
        grade: '',
        parent_a: '',
        parent_a_phone_num: '',
        nickname: '',
        school_name: '',
        birthday: '',
        parent_b: '',
        parent_b_phone_num: '',
        state: '',
        leader: '',
        remark: '',
        educational_institution_campus_id: '',
        userImageUrl: '', //责任人头像
        leaderName: '', //责任人姓名
        intended_level: 0,
        status: '', //发布状态
        is_over: false,
      },

      //邀约客户查询
      form3: {
        id: '',
        realname: '',
        sex: '',
        grade: '',
        parent_a: '',
        parent_a_phone_num: '',
        nickname: '',
        school_name: '',
        birthday: '',
        parent_b: '',
        parent_b_phone_num: '',
        state: '',
        leader: '',
        remark: '',
        educational_institution_campus_id: '',
        userImageUrl: '', //责任人头像
        leaderName: '', //责任人姓名
        intended_level: 0,
        if_real_come: '',
        date: [],
        real_come_date: '', //实际到访日期
        mine: false,
        date1: [],
      },

      dialogFormVisible3: false, //意向学员转为试听显示框
      dialogFormVisible4: false, //意向转试听提示框
      dialogFormVisible5: false, //取消转化关系
      dialogFormVisible6: false, //转为正式学员

      dialogFormVisible7: false, //修改学员信息

      school_list: [], //所属校区
      user_list: [], //校区负责人列表

      activeName: 'first',
      form: {},
      //意向客户筛选
      form1: {
        realname: '',
        leader: '',
        state: '',
        educational_institution_campus_id: '',
        mine: false,
        date: [],
        type: '',
        status: '',
        parent_a_phone_num: '',
      },

      tableData: [],
      //页码控制
      page_size: 10,
      current_pagenum: 1,
      total: 0,

      //批量导入学员
      outputs: [],
      dialogVisible: false,
      fileData: [], //文件信息
      has_error: false, //检验输入规范

      //跟进记录
      drawer: false,
      direction: 'rtl',

      form_flow: {
        remark: '',
        record_type: '',
        next_date: '', //下次跟进
        value: 0, //意向级别
        come_date: '',
        if_come_state: '',
        record_status: '',
        state: 0,
        id: '',
      },
      flowinput: true,
      recordList: [],

      //跟进记录页码控制
      page_size1: 10,
      page_no1: 1,
      total1: 0,

      //邀约查询页码控制
      page_size2: 20,
      page_no2: 1,
      total2: 0,

      //邀约查询
      sure_student_list: [], //邀约查询
      dialogVisible1: false,
      UpdateRealForm: {
        real_come_date: '',
        id: '',
      },
      value: true,
      value1: false,
    }
  },

  watch: {
    '$store.state.user.selected_schools': {
      handler(newValue) {
        console.log('校区监听')

        if (newValue.length == 0) {
          this.$message.warning('请选择校区')
        } else {
          this.form1.leader = ''
        }

        if (newValue.length == 1) {
          this.updateform.educational_institution_campus_id = this.$store.state.user.selected_schools[0]
          this.getCampusUserList()
        } else {
          this.user_list = []
          this.form1.leader = ''
        }
      },
      deep: true,
    },
  },
  async mounted() {
    if (this.$store.state.user.selected_schools.length == 0) {
      this.$message.warning('请选择校区')
      this.form1.leader = ''
      this.form3.leader = ''
    } else {
      this.form1.leader = ''
      this.form3.leader = ''
      if (this.$store.state.user.selected_schools.length == 1) {
        this.updateform.educational_institution_campus_id = this.$store.state.user.selected_schools[0]
        await this.getCampusUserList()
      }
      if (this.$attrs.methodAuthTabView('查询').viewScope === 1) {
        if (this.form1.leader && this.form3.leader) {
          this.getIntendedStudentListByRealComeDate()
        }
      } else {
        this.getIntendedStudentListByRealComeDate()
      }
    }
  },
  methods: {
    exportExcel() {
      /* 从表生成工作簿对象 */
      //var wb = XLSX.utils.table_to_book(document.querySelector("#outLTable"));
      let tableDom = document.querySelector('#outLTable').cloneNode(true)
      let tableHeader = tableDom.querySelector('.el-table__header-wrapper')
      let tableBody = tableDom.querySelector('.el-table__body')
      tableHeader.childNodes[0].append(tableBody.childNodes[1])
      let headerDom = tableHeader.childNodes[0].querySelectorAll('th')
      // 移除左侧checkbox的节点
      if (headerDom[0].querySelectorAll('.el-checkbox').length > 0) {
        headerDom[0].remove()
      }
      for (let key in headerDom) {
        if (headerDom[key].innerText === '是否到访') {
          headerDom[key].remove()
        }
      }
      // 清理掉checkbox 和操作的button
      let tableList = tableHeader.childNodes[0].childNodes[2].querySelectorAll(
        'td'
      )
      for (let key = 0; key < tableList.length; key++) {
        if (
          tableList[key].querySelectorAll('.el-checkbox').length > 0 ||
          tableList[key].querySelectorAll('.el-button').length > 0
        ) {
          tableList[key].remove()
        }
      }
      // 获取web的节点
      let webBook = XLSX.utils.table_to_book(tableHeader)
      // 把当前的book节点写入XLSX中
      let webOut = XLSX.write(webBook, {
        bookType: 'xlsx',
        bookSST: true,
        type: 'array',
      })
      try {
        FileSaver.saveAs(
          new Blob([webOut], { type: 'application/octet-stream' }),
          '邀约查询' + '.xlsx'
        )
      } catch (e) {
        if (typeof console !== 'undefined') console.log(e, webOut)
      }
    },
    //所得账号所负责的校区
    getEducationalInstitutionCampusList() {
      getEducationalInstitutionCampusList().then((res) => {
        console.log('获得分校列表')
        console.log(res)
        this.school_list = res.educational_institution_campus_list
      })
    },

    //获得校区员工列表
    async getCampusUserList() {
      return getCampusUserList({
        campusId: this.updateform.educational_institution_campus_id,
      }).then((res) => {
        console.log('获得学校用户列表')
        console.log(res)
        this.user_list = res.campusUserList
        if (this.$attrs.methodAuthTabView('查询').viewScope === 1) {
          this.form1.leader = this.$store.state.user.userInfo.id
          this.form3.leader = this.$store.state.user.userInfo.id
        }
      })
    },

    //修改学员信息
    UpateStudentInfo(row) {
      console.log('修改学员信息')
      console.log(row)
      if (row.intended_level === 1) {
        this.updateform.intended_level = '1级'
      }
      if (row.intended_level === 2) {
        this.updateform.intended_level = '2级'
      }
      if (row.intended_level === 3) {
        this.updateform.intended_level = '3级'
      }
      if (row.intended_level === 4) {
        this.updateform.intended_level = '4级'
      }
      if (row.intended_level === 5) {
        this.updateform.intended_level = '5级'
      }
      if (row.status === false) {
        this.updateform.status = '未结束'
      }
      if (row.status === true) {
        this.updateform.status = '已结束'
      }
      //TODO 学员信息
      this.updateform.realname = row.studentUserInfo.realname
      this.updateform.sex = row.studentUserInfo.sex
      this.updateform.birthday = row.studentUserInfo.birthday
      this.updateform.school_name = row.studentUserInfo.school_name
      this.updateform.grade = row.studentUserInfo.grade
      this.updateform.parent_a = row.studentUserInfo.parent_a
      this.updateform.parent_a_phone_num =
        row.studentUserInfo.parent_a_phone_num
      this.updateform.parent_b = row.studentUserInfo.parent_b
      this.updateform.parent_b_phone_num =
        row.studentUserInfo.parent_b_phone_num
      this.updateform.leader = row.studentUserInfo.leader
      this.updateform.state = row.state

      this.updateform.educational_institution_campus_id =
        row.educational_institution_campus_id
      this.updateform.remark = row.studentUserInfo.remark
      this.updateform.id = row.id

      this.updateform.userImageUrl = row.studentUserInfo.userImageUrl
      this.updateform.leaderName = row.studentUserInfo.leaderName
      this.form_flow.value = row.intended_level
      this.form_flow.state = row.state

      this.dialogFormVisible7 = true

      console.log('用户头像')
      console.log(this.updateform.userImageUrl)

      this.getEducationalInstitutionCampusList()
      this.getCampusUserList()
    },

    addOrUpdateIntendedStudent(formName) {
      if (this.updateform.intended_level === '1级') {
        this.updateform.intended_level = 1
      }
      if (this.updateform.intended_level === '2级') {
        this.updateform.intended_level = 2
      }
      if (this.updateform.intended_level === '3级') {
        this.updateform.intended_level = 3
      }
      if (this.updateform.intended_level === '4级') {
        this.updateform.intended_level = 4
      }
      if (this.updateform.intended_level === '5级') {
        this.updateform.intended_level = 5
      }
      if (this.updateform.status === '未结束') {
        this.updateform.status = 0
      }
      if (this.updateform.status === '已结束') {
        this.updateform.status = 1
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addOrUpdateIntendedStudent({
            intendedStudent_id: this.updateform.id,
            realname: this.updateform.realname,
            sex: this.updateform.sex,
            grade: this.updateform.grade,
            parent_a: this.updateform.parent_a,
            parent_a_phone_num: this.updateform.parent_a_phone_num,
            nickname: this.updateform.nickname,
            school_name: this.updateform.school_name,
            birthday: this.updateform.birthday,
            parent_b: this.updateform.parent_b,
            parent_b_phone_num: this.updateform.parent_b_phone_num,
            state: this.updateform.state,
            leader: this.updateform.leader,
            remark: this.updateform.remark,
            educational_institution_campus_id: this.updateform
              .educational_institution_campus_id,
            // status: this.updateform.status
            intended_level: this.updateform.intended_level,
            status: this.updateform.status,
          }).then((res) => {
            console.log('修改学员信息')
            console.log(res)
            if (res.is_update) {
              this.$message.success('修改成功')
              this.dialogFormVisible7 = false
              this.getIntendedStudentListByRealComeDate()
            }
          })
        }
      })
    },

    search() {
      if (this.$store.state.user.selected_schools.length == 0) {
        this.$message.warning('请选择校区')
      } else {
        this.current_pagenum = 1
      }
    },

    search1() {
      if (this.$store.state.user.selected_schools.length == 0) {
        this.$message.warning('请选择校区')
      } else {
        this.page_no2 = 1
        this.getIntendedStudentListByRealComeDate()
      }
    },

    handleSelectionChange(selection) {
      this.chooseStudents = selection
      console.log('选择的意向客户')
      console.log(this.chooseStudents)
    },

    IntentionToAudition() {
      this.FailureStudentList = []

      if (this.chooseStudents.length == 0) {
        this.$message({
          message: '请选择意向学员',
          type: 'warning',
        })
        return
      }

      this.$confirm('确定将该意向学员转为试听学员吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.form2.intendedStudentInfo = []
        this.chooseStudents.forEach((item, index) => {
          console.log(index)
          const studentinfo = {
            intendStuId: item.id,
            name: item.studentUserInfo.parent_a_phone_num,
          }
          //需要转化的学员列表
          this.form2.intendedStudentInfo.push(studentinfo)
        })
        console.log('需要转化的意向学员')
        console.log(this.form2.intendedStudentInfo)
        this.updateIndendedStudentToAuditionOrNormalOnly('1')
      })
    },

    //转为正式学员
    IntentionToFormal() {
      if (this.chooseStudents.length == 0) {
        this.$message({
          message: '请选择意向学员',
          type: 'warning',
        })
        return
      }

      this.$confirm('确定将该意向学员转为正式学员吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.form2.intendedStudentInfo = []
        this.chooseStudents.forEach((item, index) => {
          console.log(index)
          const studentinfo = {
            intendStuId: item.id,
            name: item.studentUserInfo.parent_a_phone_num,
          }
          //需要转化的学员列表
          this.form2.intendedStudentInfo.push(studentinfo)
        })
        console.log('需要转化的意向学员')
        console.log(this.form2.intendedStudentInfo)
        this.updateIndendedStudentToAuditionOrNormalOnly('2')
      })
    },

    //新增意向学员
    AddNewIntentionStudent() {
      if (
        this.$store.state.user.selected_schools.length == 0 ||
        this.$store.state.user.selected_schools.length > 1
      ) {
        this.$message.warning('请选择1个目标校区')
      } else {
        this.$router.push({
          name: 'input-student',
        })
      }
    },

    updateIndendedStudentToAuditionOrNormalOnly(opearte_state) {
      console.log(this.form2)
      updateIndendedStudentToAuditionOrNormalOnly({
        eduCampusId: this.$store.state.user.selected_schools[0],
        intendStuInfoList: this.form2.intendedStudentInfo,
        operateState: opearte_state,
      }).then((res) => {
        if (res) {
          setTimeout(() => {
            this.$notify({
              title: '警告',
              dangerouslyUseHTMLString: true,
              message: res.split('\n').join('<br/>'),
              type: 'warning',
            })
          }, 100)
        } else {
          this.$message.success(`转化${opearte_state == '1' ? '试听' : '正式'}成功`)
          this.dialogFormVisible3 = false
          this.dialogFormVisible6 = false
        }
      })
    },

    handleSizeChange(val) {
      this.page_size2 = val
      this.getIntendedStudentListByRealComeDate()
    },

    //沟通记录
    handleCurrentChange1(val) {
      this.page_no1 = val
      this.getIntendedStudentUserRecordList()
    },

    //邀约查询
    handleCurrentChange2(val) {
      this.page_no2 = val
      this.getIntendedStudentListByRealComeDate()
    },

    //移除批量导入学员
    Deleteoutputs(index) {
      console.log('移除批量导入学员')
      this.outputs.splice(index, 1)
    },

    //清除批量导入学员
    ClearMultiStudent() {
      this.outputs = []
      this.dialogVisible = false
    },

    //确认添加
    MultiAddStudent() {
      console.log('确认添加学员')
      console.log(this.outputs)
      this.has_error = false

      if (this.outputs.length == 0) {
        this.$message.warning('请录入学员信息')
        return
      } else if (this.outputs.length > 50) {
        this.$message.warning('单次批量添加学员,最大数量为50人')
        return
      } else {
        for (let k = 0; k < this.outputs.length; k++) {
          this.checkRealname(this.outputs[k].realname)
          this.checkSex(this.outputs[k].sex)
          this.checkContact(this.outputs[k].parent_a)
          this.checkPhone(this.outputs[k].parent_a_phone_num)
        }

        if (this.has_error) {
          return
        }

        var stuArr = [] //学员信息
        var stu = {
          realname: '',
          parent_a: '',
          parent_a_phone_num: '',
          sex: '',
          campusId: '',
        }

        for (let k = 0; k < this.outputs.length; k++) {
          stu = {
            realname: this.outputs[k].realname,
            parent_a: this.outputs[k].parent_a,
            parent_a_phone_num: this.outputs[k].parent_a_phone_num,
            sex: this.outputs[k].sex,
            campusId: this.$store.state.user.selected_schools[0],
          }

          stuArr.push(stu)
        }

        console.log('批量导入学员信息')
        console.log(stuArr)

        bulkAddIntendedStudent({
          stuArr: JSON.stringify(stuArr),
        }).then((res) => {
          console.log('批量导入学员')
          console.log(res)
          if (res.is_create) {
            this.$message.success('添加成功')
            this.dialogVisible = false
          }
        })
      }
    },

    //下载Excel模板

    DownLoadExcel() {
      window.open(
        'https://wugecdn.steam.fun/resources/static/%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E6%84%8F%E5%90%91%E5%AD%A6%E5%91%98.xls',
        '_blank'
      )
    },

    //打开批量导入窗口

    OpenMultiAdd() {
      if (this.$store.state.user.selected_schools.length == 0) {
        this.$message.warning('请在左上角,选择目标校区')
        return
      } else if (this.$store.state.user.selected_schools.length > 1) {
        this.$message.warning('请在左上角,选择1个目标校区')
        return
      }

      this.dialogVisible = true
    },

    //批量导入功能
    //文件选择时
    onChange(file, fileList) {
      this.fileData = file // 保存当前选择文件
      console.log(fileList)
      this.readExcel() // 调用读取数据的方法
    },

    //读取文件数据
    readExcel(e) {
      let that = this
      console.log(e)
      const files = that.fileData
      if (!files) {
        //如果没有文件
        return false
      } else if (!/\.(xls|xlsx)$/.test(files.name.toLowerCase())) {
        this.$message.error('上传格式不正确，请上传xls或者xlsx格式')
        return false
      }
      const fileReader = new FileReader()
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result
          const workbook = XLSX.read(data, {
            type: 'binary',
          })
          //导入的文件名称
          console.log(workbook.SheetNames)
          const wsname = workbook.SheetNames[0] //取第一张表
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]) //生成json表格内容
          that.outputs = [] //清空接收数据
          for (var i = 0; i < ws.length; i++) {
            var sheetData = {
              // 键名为绑定 el 表格的关键字，值则是 ws[i][对应表头名]
              //此处的字段名对应 上面表格数据的字段名
              realname: ws[i]['姓名'],
              sex: ws[i]['性别'],
              parent_a: ws[i]['家长'],
              parent_a_phone_num: ws[i]['手机号'],
            }
            that.outputs.push(sheetData)
          }
          console.log('导入的学员')
          console.log(that.outputs)
        } catch (e) {
          console.log(e)
          return false
        }
      }
      // 如果为原生 input 则应是 files[0]
      fileReader.readAsBinaryString(files.raw)
    },

    checkSpecialKey(str) {
      let specialKey =
        "[`~!#$^&*()=|{}':;'\\[\\].<>/?~！#￥……&*（）——|{}【】‘；：”“'。，、？]‘'"
      for (let i = 0; i < str.length; i++) {
        if (specialKey.indexOf(str.substr(i, 1)) != -1) {
          return false
        }
      }
      return true
    },

    checkRealname(value) {
      if (!value) {
        this.$message.warning('姓名不能为空')
        this.has_error = true
        return false
      }
      if (!this.checkSpecialKey(value)) {
        this.$message.warning('不能含有特殊字符！！')
        this.has_error = true
        return false
      }
    },

    checkSex(value) {
      if (!value) {
        this.$message.warning('性别不能为空')
        this.has_error = true
        return false
      }
      if (value !== '男' && value !== '女') {
        this.$message.warning("性别请填'男' 或 '女'")
        this.has_error = true
        return false
      }
    },

    checkContact(value) {
      if (!value) {
        this.$message.warning('家长不能为空')
        this.has_error = true
        return false
      }
      if (value !== '父亲' && value !== '母亲' && value !== '其他') {
        this.$message.warning("家长请填'父亲'、'母亲' 或 '其他'")
        this.has_error = true
        return false
      }
    },

    checkPhone(value) {
      if (!value) {
        this.$message.warning('手机号不能为空')
        this.has_error = true
        return false
      }
      if (value && !/^1[1234567890]\d{9}$/.test(value)) {
        this.$message.warning('请输入正确的手机号')
        this.has_error = true
        return false
      }
    },

    //意向客户跟进
    CloseFlowInput() {
      this.flowinput = true
      this.form_flow.record_type = ''
      this.form_flow.remark = ''
      this.form_flow.next_date = ''
      this.form_flow.come_date = ''
      this.form_flow.if_come_state = ''
    },
    OpenFlowInput() {
      this.flowinput = false
      this.form_flow.id = ''
    },

    onSubmit() {
      console.log('发布跟进记录')
    },

    AddRecordCount(row) {
      console.log('当前学员信息')
      console.log(row)
      //TODO 学员信息
      this.updateform.realname = row.studentUserInfo.realname
      this.updateform.sex = row.studentUserInfo.sex
      this.updateform.birthday = row.studentUserInfo.birthday
      this.updateform.school_name = row.studentUserInfo.school_name
      this.updateform.grade = row.studentUserInfo.grade
      this.updateform.parent_a = row.studentUserInfo.parent_a
      this.updateform.parent_a_phone_num =
        row.studentUserInfo.parent_a_phone_num
      this.updateform.parent_b = row.studentUserInfo.parent_b
      this.updateform.parent_b_phone_num =
        row.studentUserInfo.parent_b_phone_num
      this.updateform.leader = row.studentUserInfo.leader
      this.updateform.state = row.state
      this.updateform.educational_institution_campus_id =
        row.educational_institution_campus_id
      this.updateform.remark = row.studentUserInfo.remark
      this.updateform.id = row.id
      this.updateform.is_over = row.status

      this.updateform.userImageUrl = row.studentUserInfo.userImageUrl
      this.updateform.leaderName = row.studentUserInfo.leaderName

      this.form_flow.value = row.intended_level
      this.form_flow.state = row.state

      this.drawer = true
      this.getIntendedStudentUserRecordList()
    },

    addOrUpdateIntendedStudentUseRecord() {
      console.log('跟进参数')
      console.log(this.form_flow)
      console.log(this.updateform.id)

      if (!this.form_flow.record_type) {
        this.$message.warning('请选择跟进类型')
        return
      }

      if (!this.form_flow.remark) {
        this.$message.warning('请输入沟通内容')
        return
      }

      if (this.form_flow.id) {
        addOrUpdateIntendedStudentUseRecord({
          recordId: this.form_flow.id,
          intended_student_user_id: this.updateform.id,
          record_status: this.form_flow.record_status,
          record_type: this.form_flow.record_type,
          intended_level: this.form_flow.value,
          state: this.form_flow.state,
          next_date: this.form_flow.next_date,
          if_come_state: this.form_flow.if_come_state,
          come_date: this.form_flow.come_date,
          remark: this.form_flow.remark,
        }).then((res) => {
          console.log('添加跟进记录返回')
          console.log(res)
          if (res.is_update) {
            this.$message.success('记录修改成功')
            this.form_flow.id = ''
            this.CloseFlowInput()
            this.getIntendedStudentUserRecordList()
          }
        })
      } else {
        addOrUpdateIntendedStudentUseRecord({
          intended_student_user_id: this.updateform.id,
          record_status: this.form_flow.record_status,
          record_type: this.form_flow.record_type,
          intended_level: this.form_flow.value,
          state: this.form_flow.state,
          next_date: this.form_flow.next_date,
          if_come_state: this.form_flow.if_come_state,
          come_date: this.form_flow.come_date,
          remark: this.form_flow.remark,
        }).then((res) => {
          console.log('添加跟进记录返回')
          console.log(res)
          if (res.is_created) {
            this.$message.success('记录添加成功')
            this.CloseFlowInput()
            this.getIntendedStudentUserRecordList()
          }
        })
      }
    },

    //查询沟通记录
    getIntendedStudentUserRecordList() {
      getIntendedStudentUserRecordList({
        intended_student_user_id: this.updateform.id,
        start_date: '',
        end_date: '',
        page_no: this.page_no1,
        page_size: this.page_size1,
      }).then((res) => {
        console.log('查询沟通记录')
        console.log(res)
        this.recordList = res.recordList
        this.total1 = res.total
      })
    },

    //邀约查询
    getIntendedStudentListByRealComeDate() {
      if (this.form3.mine) {
        this.form3.leader = ''
      }

      getIntendedStudentListByRealComeDate({
        phone_num: this.form3.phone_num,

        realname: this.form3.realname,
        leader: this.form3.mine
          ? this.$store.state.user.userInfo.id
          : this.form3.leader,
        state: this.form3.state,
        campusIds: JSON.stringify(this.$store.state.user.selected_schools),
        if_real_come: this.form3.if_real_come,
        start_date: this.form3.date ? this.form3.date[0] : '',
        end_date: this.form3.date ? this.form3.date[1] : '',

        real_start_date: this.form3.date1 ? this.form3.date1[0] : '',
        real_end_date: this.form3.date1 ? this.form3.date1[1] : '',

        page_no: this.page_no2,
        page_size: this.page_size2,
      }).then((res) => {
        console.log('邀约查询结果')
        console.log(res)
        this.sure_student_list = res.intended_student_list

        for (let k = 0; k < this.sure_student_list.length; k++) {
          if (!this.sure_student_list[k].real_come_date) {
            this.sure_student_list[k].switch = false
          } else {
            this.sure_student_list[k].switch = true
          }
        }

        console.log('邀约客户列表')
        console.log(this.sure_student_list)

        this.total2 = res.total
      })
    },
    //更新实际到访日期
    updateRealComeDate(real_come_date, come_date, id) {
      console.log('实际到访日期')
      console.log(real_come_date)
      console.log(id)
      this.dialogVisible1 = true

      this.UpdateRealForm.id = id
      this.UpdateRealForm.real_come_date = real_come_date

      // if (!real_come_date) {
      //   console.log("请输入实际到访时间");
      //   this.dialogVisible1 = true;
      //   this.UpdateRealForm.real_come_date = come_date;
      // } else {
      //   console.log("更新到访日期");
      //   this.UpdateRealForm.real_come_date = "";
      // }
    },

    //更新到访时间
    updateIntendedStudentRealComeDate() {
      updateIntendedStudentRealComeDate({
        intendedUserId: this.UpdateRealForm.id,
        realComeDate: this.UpdateRealForm.real_come_date,
      }).then((res) => {
        console.log('实际到访日期')
        console.log(res)
        if (res.is_update) {
          this.$message.success('更新成功')
          this.getIntendedStudentListByRealComeDate()
          this.dialogVisible1 = false
        }
      })
    },

    //未到
    notArrived(real_come_date, come_date, id) {
      this.UpdateRealForm.id = id
      updateIntendedStudentRealComeDate({
        intendedUserId: this.UpdateRealForm.id,
        realComeDate: '',
      }).then((res) => {
        console.log('实际到访日期')
        console.log(res)
        if (res.is_update) {
          this.$message.success('更新成功')
          this.getIntendedStudentListByRealComeDate()
          this.dialogVisible1 = false
        }
      })
    },

    //删除跟进记录
    deleteIntendedStudentUserRecord(item) {
      var next_date = ''

      this.$confirm('确定删除本条记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        if (this.recordList.length > 1) {
          next_date = this.recordList[this.recordList.length - 1].next_date
        } else {
          next_date = ''
        }
        console.log(this.recordList)
        console.log('下次跟进日期')
        console.log(next_date)

        deleteIntendedStudentUserRecord({
          recordId: item.id,
          next_date: next_date,
        }).then((res) => {
          console.log('删除跟进记录')
          console.log(res)
          if (res.is_delete) {
            this.$message.success('删除成功')
            this.getIntendedStudentUserRecordList()
          }
        })
      })
    },

    //编辑跟进记录
    EditUserRecord(item) {
      console.log('编辑跟进记录')
      console.log(item)
      this.form_flow.id = item.id
      this.form_flow.remark = item.remark
      this.form_flow.record_type = item.record_type
      this.form_flow.next_date = item.next_date
      this.form_flow.value = item.intended_level
      this.form_flow.come_date = item.come_date
      this.form_flow.record_status = item.record_status ? '1' : '0'
      this.form_flow.state = item.state
      this.form_flow.if_come_state = item.come_date ? '1' : '0'

      this.flowinput = false
    },

    //结束跟进
    OverIntentRecord(cmd) {
      console.log('是否结束跟进')

      if (cmd == '1') {
        console.log('恢复跟进状态')
        this.$confirm('确定恢复跟进吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          console.log('确定恢复跟进')

          this.updateIntendedStudentStatus('1')
        })
      } else if (cmd == '0') {
        console.log('结束跟进状态')
        this.$confirm('确定结束跟进吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          console.log('确定结束跟进')

          this.updateIntendedStudentStatus('0')
        })
      }
    },

    //结束客户跟进
    updateIntendedStudentStatus(status) {
      updateIntendedStudentStatus({
        status: status,
        intendedStuId: this.updateform.id,
      }).then((res) => {
        console.log('改变客户跟进')
        console.log(res)
        if (res.is_update) {
          if (status == '1') {
            this.$message.success('恢复跟进')
          } else if (status == '0') {
            this.$message.success('结束跟进')
          }
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.mainNew {
  height: 100%;
}

.topTitle {
  height: 60px;
  background: #fff;
  margin: 10px;
  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;

  span {
    color: rgba(0, 0, 0, 0.45);
  }
}

.input-student-management {
  min-height: calc(100% - 30px);

  background-color: #fff;
  margin: 10px;
  border-radius: 5px;

  section {
    padding-top: 10px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 20px;

    .table-style {
      margin-top: 20px;
    }
  }

  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
    font-size: 12px;
    padding-right: 5px;
  }

  .el-icon-arrow-down {
    font-size: 12px;
  }

  .flowrecord {
    height: calc(100vh - 280px);
    margin: 20px;
    overflow-y: scroll;
  }
}
</style>

<style>
.input-student-management .el-divider--horizontal {
  margin-bottom: 20px;
  margin-top: 5px;
}
</style>
